/**
 * Sets a boolean into CanAddPersonalDataContext indicating whether the person is authorized or not to edit/add personal data.
 * If the person is not authorized a status overlay will also be shown.
 * This currently is the scenario for users with Russian IPs.
 *
 * In the rare case of error still treat the person as authorized to match behavior of https://github.com/fs-webdev/zion/blob/master/packages/router/src/PersonalDataCheck.js#L17.
 */
import React, { createContext, useContext } from 'react'
import { usePermission } from '@fs/zion-permissions'

const CanAddPersonalDataContext = createContext(true)

export default function CanAddPersonalDataProvider({ children }) {
  const [authorized, requestStatus] = usePermission('CanAddPersonalDataPermission', 'FamilyTree')
  // only display the message once
  const canAddPersonalData = requestStatus === 'loaded' ? authorized : true
  return <CanAddPersonalDataContext.Provider value={canAddPersonalData}>{children}</CanAddPersonalDataContext.Provider>
}

export function useCanAddPersonalDataContext() {
  return useContext(CanAddPersonalDataContext)
}
